import * as React from 'react';

const StopIcon = ({fillColor = '#2d2756'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={7} height={11}>
    <g data-name="Group 8634" fill={fillColor} stroke={fillColor}>
      <path data-name="Line 297" d="M1 1v9" />
      <path
        data-name="Path 5573"
        d="M1 1v9"
        strokeLinecap="round"
        strokeWidth={2}
      />
      <path
        data-name="Path 5574"
        d="M6 1v9"
        strokeLinecap="round"
        strokeWidth={2}
      />
    </g>
  </svg>
);

export default StopIcon;
